
function singleFromArrayTransform(object) {
   
    if(!object){
        return object;
    }
	if(Array.isArray(object)){
        return object;
    }
	if(object){
        
        return [object];
    }
    else
    return []
}


export default singleFromArrayTransform;
